// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conteudo{position:relative;left:-100px;padding:10px}`, "",{"version":3,"sources":["webpack://./Scripts/app/components/relaciona-obra-endereco/RelacionaObraEndereco.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA,CACA,WAAA,CACA,YAAA","sourcesContent":[".conteudo {\r\n  position: relative;\r\n  left: -100px;\r\n  padding: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
